import { ApiService } from '~/shared/api'
import { restGetItem, getList } from '~/shared/utils/decorators'
import { ServiceRestGetItem, ServiceHasList } from '~/shared/interfaces'
import { AgrocityModel } from '~/model/Agrocity'
import { isUnknownObject } from '~/shared/utils/guards'

// eslint-disable-next-line
interface AgrocityService extends ServiceHasList, ServiceRestGetItem {}

// @ts-ignore
@restGetItem
@getList

// eslint-disable-next-line no-redeclare
class AgrocityService extends ApiService {
  protected route: string = 'agrocities/get'

  getItemModel(slug: string): Promise<AgrocityModel> {
    return this.getItem(slug).then(({ data }) => {
      const raw = isUnknownObject(data) && isUnknownObject(data.data) ? data.data : null
      return new AgrocityModel(raw)
    })
  }
}

export default AgrocityService
